import { cn } from "@/lib/utils";

/** The PagePledge wordmark: "PagePledge." in Fraunces with a clay dot. */
export default function Wordmark({ href = "/", className }) {
  return (
    <a href={href} className={cn("font-display text-xl font-semibold text-foreground transition-colors hover:text-primary", className)}>
      PagePledge<span className="text-primary">.</span>
    </a>
  );
}
